import styled, { css } from 'styled-components';
import { calculateGridItemChildWidth } from '../../commonStyles/innerGridItemColumn';
import colors from '../../helpers/colors';
import fonts from '../../helpers/fonts';
import mediaQuery from '../../helpers/mediaQuery';
import spacing, { spacingWithBorder } from '../../helpers/spacing';
import fluidGridColumns from '../../theme/fluidGridColumns';
import { SecondaryCta } from '../Cta';
import { GridItem } from '../Grid';
import {
  ctaBannerGridItemProps,
  textWidthWithCtaInColumns,
  textWidthWithoutCtaInColumns,
} from './layout';

export type CtaBannerWrapperProps = {
  subheading: string | undefined;
};

export const CtaBannerContainer = styled.div`
  margin: ${spacing(4)} 0;

  ${mediaQuery.tabletLandscape`
    margin: ${spacing(6)} 0;
  `}
`;

export const CtaBannerGridItem = styled(GridItem)<CtaBannerWrapperProps>`
  border: 1px solid ${colors.cardBorder};
  border-radius: ${({ theme }) => `${theme.cardRadius}`};

  display: flex;
  flex-direction: column;
  padding: ${spacingWithBorder(4, 1)} ${spacingWithBorder(3, 1)};

  ${mediaQuery.tabletPortrait`
    ${({ subheading }) =>
      subheading
        ? css`
            flex-direction: column;
          `
        : css`
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
          `}
  `}

  ${mediaQuery.tabletLandscape`
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: ${spacingWithBorder(4, 1)};
  `}
`;

export const Heading = styled.h3`
  ${fonts.headingSmall};
  margin: 0;
`;

export const Subheading = styled.p`
  ${fonts.paragraph};

  margin: ${spacing(2)} 0 0;

  ${mediaQuery.tabletPortrait`
    margin-bottom: ${spacing(4)};
  `}

  ${mediaQuery.tabletLandscape`
    margin-bottom: 0;
  `}
`;

export const CtaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  white-space: nowrap;

  margin-top: ${spacing(4)};

  ${mediaQuery.tabletPortrait`
    flex-direction: row;
    margin: 0;
  `}
`;

export const StyledSecondaryCta = styled(SecondaryCta)`
  margin-top: ${spacing(2)};

  ${mediaQuery.tabletPortrait`
    margin-left: ${spacing(2)};
    margin-top: 0;
  `}
`;

type TextWrapperProps = {
  twoCtas: boolean | undefined;
  subheading: string | undefined;
};

export const TextWrapper = styled.div<TextWrapperProps>`

  ${mediaQuery.tabletPortrait`
    ${({ subheading }) =>
      !subheading &&
      css`
        margin-right: ${spacing(3)};
      `}
  `}

  /*  We don't want to display the answer across the full banner for the wider breakpoints, to follow
      best practices for long copy
  */
  ${mediaQuery.tabletLandscape`
    width: ${({ theme, twoCtas }) =>
      calculateGridItemChildWidth(
        ctaBannerGridItemProps.tabletLandscape ?? fluidGridColumns.tabletLandscape,
        twoCtas
          ? textWidthWithCtaInColumns.tabletLandscape
          : textWidthWithoutCtaInColumns.tabletLandscape,
        'tabletLandscape',
        spacing(4)({ theme })
      )};
    margin-right: 0;
  `}

  ${mediaQuery.desktop`
    width: ${({ theme, twoCtas }) =>
      calculateGridItemChildWidth(
        ctaBannerGridItemProps.desktop ?? fluidGridColumns.desktop,
        twoCtas
          ? textWidthWithCtaInColumns.desktop
          : textWidthWithoutCtaInColumns.desktop,
        'desktop',
        spacing(4)({ theme })
      )};
  `}
`;
